import axios from 'axios';
import ResponseErrorHandel from "../ReponseErrorHandeler/StatusHandel.js";




const apiRequests = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});



export default apiRequests;


apiRequests.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("accessToken") ||
      sessionStorage.getItem("accessToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);



apiRequests.interceptors.response.use(
    (res) => {
        return res
    },

    error => {
        ResponseErrorHandel(error)
        return Promise.reject(error)

    }
)



